import { DiffuseTripBookingsResponse } from '../../lib/types/models/center/center'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const diffuseTripBookings = (ids: number[]) => {
  return restApiClient
    .url(constructApiUrl(API.centers.diffuseTripBookings.url, null))
    .post<DiffuseTripBookingsResponse>({ ids })
}
